<template>
	<div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb class="bnone">
			<el-breadcrumb-item>系统设置</el-breadcrumb-item>
			<el-breadcrumb-item>支付配置</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form ref="form" label-position="right" :model="item" label-width="auto" show-message inline-message
			status-icon>
			<el-divider content-position="left">微信支付 V3 版本</el-divider>
			<el-form-item label="Mchid">
				<el-input v-model="item.wxMchid"></el-input>
			</el-form-item>
			<el-form-item label="V3密钥">
				<el-input v-model="item.wxKeyV3"></el-input>
			</el-form-item>
			<el-form-item label="证书序列号">
				<el-input v-model="item.wxSslNumber"></el-input>
			</el-form-item>
			<!-- <el-form-item label="商户私钥">
				<el-upload list-type="text" :on-remove="uploadRemove" :on-success="uploadSuccess" :file-list="wxSslKey"
					:on-error="uploadError" drag :action="app_url + '/Upload/ssl'" accept=".pem">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-form-item> -->
			<el-form-item label="商户私钥">
				<el-input
				  type="textarea"
				  :rows="2"
				  placeholder="请输入商户私钥"
				  v-model="item.wxSslKey">
				</el-input>
			</el-form-item>
			<el-divider content-position="left">微信支付 V2 版本</el-divider>
			<el-form-item label="V2密钥">
				<el-input v-model="item.wxKeyV2"></el-input>
			</el-form-item>
			<!-- <el-form-item label="商户证书">
				<el-upload list-type="text" :on-remove="uploadRemovePublic" :on-success="uploadSuccessPublic"
					:file-list="wxSslCert" :on-error="uploadError" drag :action="app_url + '/Upload/ssl'" accept=".pem">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
				</el-upload>
			</el-form-item> -->
			<el-form-item label="商户证书">
				<el-input
				  type="textarea"
				  :rows="2"
				  placeholder="请输入商户证书"
				  v-model="item.wxSslCert">
				</el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submit">保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				item: {},
				isLoad: false,
				// wxSslKey: [],
				// wxSslCert: [],
			}
		},
		created() {
			this.loadItem()
		},
		methods: {
			loadItem() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/admin/setting/payment').
				then(res => {
					this.isLoad = !this.isLoad
					if (res.data.length) {
						this.item = res.data[0]
					}
					// if (this.item.wxSslKey) {
					// 	this.wxSslKey = [{
					// 		name: this.item.wxSslKey,
					// 		url: this.item.wxSslKey,
					// 		response: {
					// 			data: {
					// 				src: this.item.wxSslKey
					// 			}
					// 		}
					// 	}]
					// }
					// if (this.item.wxSslCert) {
					// 	this.wxSslCert = [{
					// 		name: this.item.wxSslCert,
					// 		url: this.item.wxSslCert,
					// 		response: {
					// 			data: {
					// 				src: this.item.wxSslCert
					// 			}
					// 		}
					// 	}]
					// }
				}).catch(() => {
					this.isLoad = !this.isLoad
				})
			},
			submit() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad

				// if (this.wxSslKey[0]) {
				// 	this.$set(this.item, 'wxSslKey', this.wxSslKey[0].response.data.src)
				// } else {
				// 	this.$set(this.item, 'wxSslKey', '')
				// }

				// if (this.wxSslCert[0]) {
				// 	this.$set(this.item, 'wxSslCert', this.wxSslCert[0].response.data.src)
				// } else {
				// 	this.$set(this.item, 'wxSslCert', '')
				// }

				this.axios.post('/admin/setting/paymentEdit', this.item).then(res => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '保存成功'
					});
				}).catch(() => {
					this.isLoad = !this.isLoad
				})

			},
			// uploadError() {
			// 	this.$notify.error({
			// 		message: '上传失败'
			// 	});
			// },
			// uploadRemove() {
			// 	this.wxSslKey = []
			// },
			// uploadSuccess(res, file) {
			// 	file.name = res.url
			// 	this.wxSslKey = [file]
			// 	this.$notify.success({
			// 		message: '上传成功'
			// 	});
			// },
			// uploadRemovePublic() {
			// 	this.wxSslCert = []
			// },
			// uploadSuccessPublic(res, file) {
			// 	file.name = res.url
			// 	this.wxSslCert = [file]
			// 	this.$notify.success({
			// 		message: '上传成功'
			// 	});
			// }
		}
	}
</script>
<style>
</style>
